import { OPEN_MODAL_WINDOW, CLOSE_MODAL_WINDOW, CLOSE_ALL_MODAL_WINDOWS } from './modal-actions';

const initialState = [];

export const modalWindow = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL_WINDOW:
      return state.concat(action.payload);

    case CLOSE_MODAL_WINDOW:
      return state.slice(0, -1);

    case CLOSE_ALL_MODAL_WINDOWS:
      return initialState;

    default:
      return state;
  }
};
